/* redeploy */
import React from "react";
import NewMembersTable from "./NewMembersTable";
import TopPerformersTable from "../retail/TopPerformersTable";
import NewSubmissionsTable from "./NewSubmissionsTable";
import InfoBlocks from "./InfoBlocks";
import HomeEngagementChart from "../reuseableComponents/HomeEngagementChart";
import { ENGAGEMENT_TYPES } from "../../../../storage/constants";
import styled from "styled-components";

const PaddingWrap = styled.div`
  padding: 16px;
`;

const getSubsByType = (submissions, submissionsType) => {
  try {
    if (submissionsType === ENGAGEMENT_TYPES.ASSIGNED) {
      return submissions.filter((sub) => sub.assigned);
    }
    if (submissionsType === ENGAGEMENT_TYPES.EXTRACREDIT) {
      return submissions.filter((sub) => !sub.assigned);
    }

    return submissions;
  } catch (error) {
    return [];
  }
};

const SingleLocationView = ({ data, submissionsType }) => {
  const recentSubmissionsByType = getSubsByType(
    data.current_location?.submissions.recent_submissions || [],
    submissionsType,
  );

  return (
    <>
      <PaddingWrap>
        <InfoBlocks
          data={data?.current_location}
          submissionsType={submissionsType}
        />
      </PaddingWrap>
      <PaddingWrap>
        <HomeEngagementChart
          submissions={recentSubmissionsByType}
          isVendor={false}
          engagementType={submissionsType}
        />
      </PaddingWrap>
      <PaddingWrap>
        <TopPerformersTable
          submissions={recentSubmissionsByType}
          submissionsType={submissionsType}
          isManager
        />
      </PaddingWrap>
      <PaddingWrap>
        <NewSubmissionsTable
          newSubmissions={recentSubmissionsByType}
          submissionsType={submissionsType}
        />
      </PaddingWrap>
      <PaddingWrap>
        <NewMembersTable
          newEmployees={data.current_location?.team_members.recent}
        />
      </PaddingWrap>
    </>
  );
};

export default SingleLocationView;
